<div class="custom_modal">
  <div class="modal-header">
    <div class="title" [innerHTML]="'SHARED.MODAL.HEADER_EMAIL' | translate"></div>
    <div>
      <span class="close_button" (click)="close(false)">
        <i class="fa fa-times"></i>
      </span>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="selectEmailAddressesForm" *ngIf="data.emailAddresses.length > 0">
      <eps-select formControlName="selectedEmailAddresses" [options]="data.emailAddresses" [multiple]="true" labelPosition="none" [showErrors]="false"></eps-select>
    </form>
    <span *ngIf="data.emailAddresses.length === 0">{{ 'EMAIL_ACTORS.LIST.NO_EMAIL_ACTORS' | translate }}</span>
  </div>
  <div class="modal-footer">
    <eps-button
      type="link"
      label="SHARED.BUTTONS.CANCEL"
      (buttonClick)="close(false)"
    ></eps-button>
    <eps-button
      buttonIcon="square-plus"
      label="SHARED.BUTTONS.SUBMIT"
      (buttonClick)="close(true)"
      submit
    ></eps-button>
  </div>
</div>
